import Vue from 'vue';
import _ from 'lodash';
import inputLimiter from './directive/inputLimiter';

// 防抖指令
Vue.directive('debounce', {
  inserted: function (el, binding) {
    el.addEventListener('click', _.debounce(binding.value, 300));
  },
});

// 输入限制指令
Vue.directive('input-limiter', inputLimiter);
